import defaultValue from '@/constants/data-panel-default-data';

export default defaultValue;
